export interface AlertBannerConfig {
  bgClass: string;
  bgColor?: string;
  iconName: string;
  iconColorClass: string;
  textColorClass: string;
}

export enum BgClassEnum {
  INFO = 'bg-primary',
  SUCCESS = 'bg-green-400',
  ERROR = 'bg-red-500',
  DEFAULT = 'bg-gray-50',
}

export enum BgColorEnum {
  WARNING = 'rgb(234 185 0)',
}

export enum ContentColorClassEnum {
  INFO = 'text-white',
  SUCCESS = 'text-white',
  WARNING = 'text-white',
  ERROR = 'text-white',
  DEFAULT = 'text-gray-500',
}

export enum IconNameEnum {
  INFO = 'info',
  SUCCESS = 'check_circle',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'info',
}

export type AlertTypes = 'info' | 'success' | 'warning' | 'error' | 'default';

export const TYPE_CONFIG = {
  info: {
    bgClass: BgClassEnum.INFO,
    iconName: IconNameEnum.INFO,
    iconColorClass: ContentColorClassEnum.INFO,
    textColorClass: ContentColorClassEnum.INFO,
  },
  success: {
    bgClass: BgClassEnum.SUCCESS,
    iconName: IconNameEnum.SUCCESS,
    iconColorClass: ContentColorClassEnum.SUCCESS,
    textColorClass: ContentColorClassEnum.SUCCESS,
  },
  warning: {
    bgClass: '',
    bgColor: BgColorEnum.WARNING,
    iconName: IconNameEnum.WARNING,
    iconColorClass: ContentColorClassEnum.WARNING,
    textColorClass: ContentColorClassEnum.WARNING,
  },
  error: {
    bgClass: BgClassEnum.ERROR,
    iconName: IconNameEnum.ERROR,
    iconColorClass: ContentColorClassEnum.ERROR,
    textColorClass: ContentColorClassEnum.ERROR,
  },
  default: {
    bgClass: BgClassEnum.DEFAULT,
    iconName: IconNameEnum.DEFAULT,
    iconColorClass: ContentColorClassEnum.DEFAULT,
    textColorClass: ContentColorClassEnum.DEFAULT,
  },
};
